class VBFLocalization extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      trigger: this.querySelector('button.open'),
      dialog: this.querySelector('dialog'),
      overlay: this.querySelector('.vbf-localization__overlay'),
      dropdown: this.querySelector('.dropdown'),
      close: this.querySelector('.vbf-localization__close'),
      confirm: this.querySelector('.vbf-localization__confirm'),
    }

    this.elements.trigger.addEventListener('click', this.onTriggerClick.bind(this))
    this.elements.close.addEventListener('click', this.onCloseClick.bind(this))
    this.elements.overlay.addEventListener('click', this.onBodyClick.bind(this))
    this.elements.confirm.addEventListener('click', this.confirm.bind(this))

    if (this.elements.dropdown !== null) {
      this.createCustomDropdown(this.elements.dropdown)
    }
  }

  createCustomDropdown (dropdown) {
    const options = dropdown.querySelectorAll('option')
    const optionsArr = Array.prototype.slice.call(options)
    const customDropdown = document.createElement('div')
    const selected = document.createElement('div')
    const menu = document.createElement('div')
    const search = document.createElement('input')
    const menuInnerWrapper = document.createElement('ul')

    customDropdown.classList.add('dropdown')
    selected.tabIndex = 0
    selected.classList.add('dropdown-select')
    menu.classList.add('dropdown-menu')
    search.classList.add('dropdown-menu-search')
    menuInnerWrapper.classList.add('dropdown-menu-inner')

    dropdown.insertAdjacentElement('afterend', customDropdown)

    selected.textContent = this.dataset.currentStore
    customDropdown.appendChild(selected)
    customDropdown.appendChild(menu)

    selected.addEventListener('click', this.toggleDropdown.bind(menu))
    selected.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        selected.click()
      }
    })

    search.placeholder = 'Search...'
    search.type = 'text'

    menu.appendChild(search)
    menu.appendChild(menuInnerWrapper)

    optionsArr.forEach((option) => {
      const item = document.createElement('li')
      item.tabIndex = 0
      item.classList.add('dropdown-menu-item')
      if (this.dataset.currentStore === option.textContent) {
        item.classList.add('is-select')
      }
      item.dataset.value = option.value
      item.textContent = option.textContent
      menuInnerWrapper.appendChild(item)

      item.addEventListener('click', this.setSelected.bind(item, selected, dropdown, menu))
      item.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          item.click()
        }
      })
    })

    search.addEventListener('input', this.filterItems.bind(search, optionsArr, menu))
    document.addEventListener('click', this.closeIfClickedOutside.bind(customDropdown, menu))
    dropdown.style.display = 'none'
  }

  onBodyClick (event) {
    if (event.target.classList.contains('vbf-localization__overlay')) {
      return this.onCloseClick()
    }
  }

  onTriggerClick () {
    this.elements.dialog.showModal()
  }

  onCloseClick () {
    this.elements.dialog.close()
  }

  confirm () {
    const selectedIso = this.querySelector('.dropdown-select').dataset.isoCode

    if (selectedIso === undefined) {
      this.onCloseClick()
    } else if (selectedIso === this.dataset.currentIso) {
      this.onCloseClick()
    } else {
      let newMarket = ''
      if (selectedIso !== 'GB') {
        newMarket = `en-${selectedIso.toLowerCase()}`
      }
      const url = new URL(window.location.href)
      const pathParts = url.pathname.split('/').filter(Boolean)
      const hasLocale = /^en-[a-z]{2}$/i.test(pathParts[0])

      if (hasLocale) {
        pathParts[0] = newMarket
      } else {
        pathParts.unshift(newMarket)
      }

      url.pathname = `/${pathParts.join('/')}`
      window.location.href = url.toString()
    }
  }

  toggleDropdown () {
    if (this.offsetParent !== null) {
      this.style.display = 'none'
    } else {
      this.style.display = 'block'
      this.querySelector('input').focus()
    }
  }

  setSelected (selected, dropdown, menu) {
    const value = this.dataset.value
    const label = this.textContent

    selected.textContent = label
    selected.dataset.isoCode = value
    dropdown.value = value
    menu.style.display = 'none'
    menu.querySelector('input').value = ''
    menu.querySelectorAll('li').forEach((li) => {
      if (li.classList.contains('is-select')) {
        li.classList.remove('is-select')
      }
      if (li.offsetParent === null) {
        li.style.display = 'block'
      }
    })
    this.classList.add('is-select')
  }

  filterItems (itemsArr, menu) {
    const customOptions = menu.querySelectorAll('.dropdown-menu-inner li')
    const searchValue = this.value.toLowerCase()
    const filteredItems = itemsArr.filter((item) => item.textContent.toLowerCase().includes(searchValue))
    const indexesArr = filteredItems.map((item) => itemsArr.indexOf(item))

    itemsArr.forEach((option) => {
      if (!indexesArr.includes(itemsArr.indexOf(option))) {
        customOptions[itemsArr.indexOf(option)].style.display = 'none'
      } else {
        if (customOptions[itemsArr.indexOf(option)].offsetParent === null) {
          customOptions[itemsArr.indexOf(option)].style.display = 'block'
        }
      }
    })
  }

  closeIfClickedOutside (menu, e) {
    if (
      e.target.closest('.dropdown') === null &&
      e.target !== this &&
      menu.offsetParent !== null
    ) {
      menu.style.display = 'none'
    }
  }
}

customElements.define('vbf-localization', VBFLocalization)
